(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
const setupFuntoContactValidation = root => {
  root.querySelectorAll('contact-form form').forEach(form => {
    if(form.dataset.funtoValidation)return;
    form.dataset.funtoValidation='true';
    const fields=[...form.querySelectorAll('input:not([type="hidden"]),textarea,select')];
    const copy=form.closest('contact-form').dataset;
    const message=field=>{
      if(field.type==='checkbox')return copy.errorConfirmation;
      if(field.tagName==='SELECT')return copy.errorSelection;
      if(field.validity.valueMissing||field.validity.customError)return copy.errorRequired;
      if(field.type==='email'&&field.validity.typeMismatch)return copy.errorEmail;
      return copy.errorInvalid;
    };
    const validateWhitespace=field=>{
      if(!field.required||!['text','textarea','email','tel'].includes(field.type))return;
      field.setCustomValidity(field.value.length&&!field.value.trim()?copy.errorRequired:'');
    };
    fields.forEach(field=>{
      const wrapper=field.closest('.field-wrapper');
      let error=wrapper?.querySelector('.field-wrapper__error-msg');
      if(!error&&wrapper){
        error=document.createElement('small');
        error.className='contact__field-error field-wrapper__error-msg hidden';
        wrapper.append(error);
      }
      if(error){
        error.setAttribute('aria-live','polite');
        error.id=field.id+'-validation-error';
        const ids=new Set((field.getAttribute('aria-describedby')||'').split(' ').filter(Boolean));
        ids.add(error.id);
        field.setAttribute('aria-describedby',[...ids].join(' '));
      }
      field.addEventListener('invalid',event=>{
        event.preventDefault();
        const first=fields.find(item=>!item.validity.valid);
        if(first!==field)return;
        fields.forEach(item=>{
          item.removeAttribute('aria-invalid');
          item.closest('.field-wrapper')?.querySelector('.field-wrapper__error-msg')?.classList.add('hidden');
        });
        field.setAttribute('aria-invalid','true');
        if(error){error.textContent=message(field);error.classList.remove('hidden');}
        field.focus();
      });
      const refresh=()=>{
        validateWhitespace(field);
        if(field.validity.valid){
          field.removeAttribute('aria-invalid');
          error?.classList.add('hidden');
        }else if(field.getAttribute('aria-invalid')==='true'&&error){
          error.textContent=message(field);
        }
      };
      field.addEventListener('input',refresh);
      field.addEventListener('change',refresh);
      validateWhitespace(field);
    });
  });
};
setupFuntoContactValidation(document);
document.addEventListener('shopify:section:load',event=>setupFuntoContactValidation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funto-art-invitation"] && !Shopify.designMode) return;
  try {
    
function initFuntoArtInvites(){document.querySelectorAll('[data-art-invite]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const link=root.querySelector('[data-copy-open]');const status=root.querySelector('[data-copy-status]');const input=root.querySelector('[data-manual-tags]');const selectTags=()=>{const selection=window.getSelection();const range=document.createRange();range.selectNodeContents(input);selection.removeAllRanges();selection.addRange(range)};input.addEventListener('click',selectTags);link.addEventListener('click',()=>{if(!navigator.clipboard){status.textContent=status.dataset.failure;input.focus();selectTags();return}navigator.clipboard.writeText(link.dataset.tags).then(()=>{status.textContent=status.dataset.success}).catch(()=>{status.textContent=status.dataset.failure;input.focus();selectTags()})})})}initFuntoArtInvites();document.addEventListener('shopify:section:load',initFuntoArtInvites);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funto-creator-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('funto-creator-videos')) {
  customElements.define('funto-creator-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const player = this.querySelector('[data-player]');
      const more = this.querySelector('[data-more]');
      if (more) more.addEventListener('click', () => {
        const hidden = [...this.querySelectorAll('.funto-cv__card[hidden]')];
        const batch = Math.max(1, Number(this.dataset.batch) || 3);
        hidden.slice(0, batch).forEach(card => card.hidden = false);
        more.setAttribute('aria-expanded', 'true');
        if (hidden.length <= batch) more.hidden = true;
      });
      this.querySelectorAll('[data-video-id]').forEach(button => {
        button.addEventListener('click', () => {
          const id = button.dataset.videoId;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
          const iframe = document.createElement('iframe');
          const start = Math.max(0, parseInt(button.dataset.start, 10) || 0);
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&start=' + start;
          iframe.title = button.dataset.title;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.querySelector('[data-dialog-title]').textContent = button.dataset.title;
          this.querySelector('[data-source-link]').href = button.dataset.source;
          dialog.classList.toggle('is-short', button.dataset.source.includes('/shorts/'));
          player.replaceChildren(iframe);
          dialog.showModal();
          dialog.scrollTop = 0;
          this.querySelector('[data-close]').focus({ preventScroll: true });
        });
      });
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => player.replaceChildren());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funto-ft1085-value"] && !Shopify.designMode) return;
  try {
    
function initFuntoDemos(){document.querySelectorAll('[data-funto-demo="true"]').forEach(root=>{if(root.dataset.demoReady)return;root.dataset.demoReady="true";const videos=[...root.querySelectorAll("video")];if(!videos.length)return;const visible=new Map();const reduced=window.matchMedia("(prefers-reduced-motion: reduce)");const update=()=>{const mobile=matchMedia("(max-width:749px)").matches;const chosen=videos.reduce((best,v)=>(visible.get(v)||0)>(visible.get(best)||0)?v:best,videos[0]);videos.forEach(v=>{const active=!document.hidden&&!reduced.matches&&(visible.get(v)||0)>.65&&(!mobile||v===chosen);if(active){v.querySelectorAll("source[data-src]").forEach(source=>{source.src=source.dataset.src;source.removeAttribute("data-src")});if(!v.dataset.sourcesLoaded){v.load();v.dataset.sourcesLoaded="true"}v.play().catch(()=>{})}else v.pause()})};const observer=new IntersectionObserver(entries=>{entries.forEach(e=>visible.set(e.target,e.intersectionRatio));update()},{threshold:[0,.65,.9,1]});videos.forEach(v=>{v.muted=true;observer.observe(v)});document.addEventListener("visibilitychange",update);reduced.addEventListener("change",update)})}initFuntoDemos();document.addEventListener("shopify:section:load",initFuntoDemos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funto-gallery-more"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('funto-gallery-more')) {
    customElements.define('funto-gallery-more', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const main = this.closest('main');
        this.button = this.querySelector('button');
        this.controls = this.querySelector('.funto-gallery-more__controls');
        this.status = this.querySelector('[role="status"]');
        if (!main || !this.button || !this.controls || !this.status) return;
        this.cards = [...new Set([...main.querySelectorAll('.funto-artwork-open')]
          .map(link => link.closest('.custom-columns__column')).filter(Boolean))];
        this.rows = [...new Set(this.cards.map(card => card.closest('.shopify-section')).filter(Boolean))];
        this.cards.forEach(card => card.classList.add('funto-gallery-card'));
        this.rows.forEach(row => row.classList.add('funto-gallery-row'));
        this.limit = Math.max(1, Number(this.dataset.initialCount) || 16);
        this.batchSize = Math.max(1, Number(this.dataset.batchSize) || 8);
        this.editorMode = this.dataset.editor === 'true';
        if (this.editorMode) this.limit = this.cards.length;
        this.button.setAttribute('aria-controls', this.rows.map(row => row.id).join(' '));
        this.hidden = this.cards.length === 0 || this.editorMode;
        this.render(false);
        const scheduleFill = () => {
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.fillInitialViewport());
        };
        scheduleFill();
        window.addEventListener('resize', scheduleFill, { signal: this.controller.signal });
        this.cards.forEach(card => {
          card.querySelectorAll('img').forEach(img => {
            if (!img.complete) img.addEventListener('load', scheduleFill, { once: true, signal: this.controller.signal });
          });
        });
        this.button.addEventListener('click', () => {
          const firstNewCard = this.cards[this.limit];
          this.limit += this.batchSize;
          this.render(true);
          firstNewCard?.querySelector('.funto-artwork-open')?.focus({ preventScroll: true });
        }, { signal: this.controller.signal });
        document.addEventListener('shopify:section:load', () => this.initialize(), { signal: this.controller.signal });
      }

      fillInitialViewport() {
        if (!this.isConnected || this.editorMode || !this.cards.length) return;
        const first = this.cards[0];
        const targetHeight = window.innerHeight * 2;
        while (this.limit < this.cards.length) {
          const last = this.cards[Math.min(this.limit, this.cards.length) - 1];
          if (last.getBoundingClientRect().bottom - first.getBoundingClientRect().top >= targetHeight) break;
          this.limit = Math.min(this.cards.length, this.limit + 4);
          this.render(false);
        }
      }

      render(announce) {
        this.cards.forEach((card, index) => { card.hidden = index >= this.limit; });
        this.rows.forEach(row => {
          row.hidden = this.cards.filter(card => row.contains(card)).every(card => card.hidden);
        });
        this.controls.hidden = this.limit >= this.cards.length || this.editorMode;
        if (announce) {
          this.status.textContent = this.dataset.statusTemplate
            .replace('[shown]', Math.min(this.limit, this.cards.length))
            .replace('[total]', this.cards.length);
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.layoutFrame);
        this.controller?.abort();
        this.cards?.forEach(card => { card.hidden = false; card.classList.remove('funto-gallery-card'); });
        this.rows?.forEach(row => { row.hidden = false; row.classList.remove('funto-gallery-row'); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funto-home-gallery"] && !Shopify.designMode) return;
  try {
    
function setupFuntoGallery(){
  document.querySelectorAll(".funto-home-gallery").forEach(root=>{
    if(root.dataset.galleryReady)return;
    root.dataset.galleryReady="true";
    const mobile=window.matchMedia("(max-width:749px)");
    const reduced=window.matchMedia("(prefers-reduced-motion:reduce)");
    const rows=[...root.querySelectorAll(".funto-home-gallery__row")];
    const refreshTracks=()=>{
      root.querySelectorAll(".funto-home-gallery__track").forEach(track=>{
        const [first,second]=track.querySelectorAll(".funto-home-gallery__group");
        if(!first||!second)return;
        first.querySelectorAll("[data-gallery-repeat]").forEach(item=>item.remove());
        const originals=[...first.children];
        if(!originals.length)return;
        const baseWidth=first.getBoundingClientRect().width;
        if(!baseWidth)return;
        const repeats=Math.max(1,Math.ceil(track.parentElement.clientWidth/baseWidth));
        for(let n=1;n<repeats;n++){
          originals.forEach(item=>{
            const clone=item.cloneNode(true);
            clone.dataset.galleryRepeat="true";
            clone.removeAttribute("data-shopify-editor-block");
            clone.setAttribute("aria-hidden","true");
            first.append(clone);
          });
        }
        second.replaceChildren(...[...first.children].map(item=>{
          const clone=item.cloneNode(true);
          clone.removeAttribute("data-shopify-editor-block");
          return clone;
        }));
        track.style.animationDuration=(first.getBoundingClientRect().width/30)+"s";
        if(mobile.matches){
          const row=track.parentElement;
          row.scrollLeft=row.classList.contains("funto-home-gallery__row--right")?first.getBoundingClientRect().width:0;
        }
      });
    };
    refreshTracks();
    const observer=new ResizeObserver(refreshTracks);
    rows.forEach(row=>observer.observe(row));
    let idleUntil=0;
    let last=0;
    rows.forEach(row=>{
      row.addEventListener("pointerdown",()=>{idleUntil=Infinity},{passive:true});
      const resume=()=>{idleUntil=performance.now()+2500};
      row.addEventListener("pointerup",resume,{passive:true});
      row.addEventListener("pointercancel",resume,{passive:true});
    });
    const tick=time=>{
      if(!root.isConnected){observer.disconnect();return}
      if(mobile.matches&&!reduced.matches&&last&&time>=idleUntil){
        rows.forEach(row=>{
          const group=row.querySelector(".funto-home-gallery__group");
          const span=group?.getBoundingClientRect().width||0;
          if(!span)return;
          let next=row.scrollLeft+(row.classList.contains("funto-home-gallery__row--right")?-1:1)*Math.min(time-last,50)*0.03;
          if(next>=span)next-=span;
          if(next<=0)next+=span;
          row.scrollLeft=next;
        });
      }
      last=time;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
}
setupFuntoGallery();
document.addEventListener("shopify:section:load",setupFuntoGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-p4"]) return;
  try {
    
if (!customElements.get('funto-purchase-gate')) {
  customElements.define('funto-purchase-gate', class extends HTMLElement {
    connectedCallback() {
      this.cancelled = false;
      this.fieldset = this.querySelector('[data-purchase-controls]');
      this.status = this.querySelector('[data-purchase-status]');
      if (!this.fieldset) return;
      this.blockEarlySubmit = event => {
        if (this.fieldset.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.addEventListener('submit', this.blockEarlySubmit, true);
      this.timer = setTimeout(() => this.showError(), 15000);
      this.prepare().catch(() => this.showError());
    }

    async prepare() {
      if (document.readyState === 'loading') {
        await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
      }
      const names = ['product-form', 'product-info-upsell', 'funto-kit-addons', 'funto-cart-total', 'sticky-atc'];
      await Promise.all(names.filter(name => this.querySelector(name)).map(name => customElements.whenDefined(name)));
      await new Promise(resolve => requestAnimationFrame(resolve));
      if (this.cancelled || !this.isConnected) return;
      const total = this.querySelector('funto-cart-total');
      const form = this.querySelector('product-form form');
      const button = form?.querySelector('[type="submit"][name="add"]');
      if (!form || !button || !total || typeof total.update !== 'function') throw new Error('Purchase controls are not ready');
      total.update();
      if (!button.disabled && button.dataset.unavailable !== 'true' && button.querySelector('.main-atc-price') && !button.dataset.funtoTotal) {
        throw new Error('Purchase total is not ready');
      }
      clearTimeout(this.timer);
      this.dataset.ready = 'true';
      this.fieldset.disabled = false;
      this.fieldset.removeAttribute('aria-busy');
      if (this.status) this.status.hidden = true;
    }

    showError() {
      if (this.cancelled || this.dataset.ready === 'true' || !this.status) return;
      this.status.querySelector('[data-purchase-loading]')?.setAttribute('hidden', '');
      this.status.querySelector('[data-purchase-retry]')?.removeAttribute('hidden');
    }

    disconnectedCallback() {
      this.cancelled = true;
      clearTimeout(this.timer);
      this.removeEventListener('submit', this.blockEarlySubmit, true);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
function initFuntoDemos(){document.querySelectorAll('[data-funto-demo="true"]').forEach(root=>{if(root.dataset.demoReady)return;root.dataset.demoReady="true";const videos=[...root.querySelectorAll("video")];if(!videos.length)return;const visible=new Map();const reduced=window.matchMedia("(prefers-reduced-motion: reduce)");const update=()=>{const mobile=matchMedia("(max-width:749px)").matches;const chosen=videos.reduce((best,v)=>(visible.get(v)||0)>(visible.get(best)||0)?v:best,videos[0]);videos.forEach(v=>{const active=!document.hidden&&!reduced.matches&&(visible.get(v)||0)>.65&&(!mobile||v===chosen);if(active){v.querySelectorAll("source[data-src]").forEach(source=>{source.src=source.dataset.src;source.removeAttribute("data-src")});if(!v.dataset.sourcesLoaded){v.load();v.dataset.sourcesLoaded="true"}v.play().catch(()=>{})}else v.pause()})};const observer=new IntersectionObserver(entries=>{entries.forEach(e=>visible.set(e.target,e.intersectionRatio));update()},{threshold:[0,.65,.9,1]});videos.forEach(v=>{v.muted=true;observer.observe(v)});document.addEventListener("visibilitychange",update);reduced.addEventListener("change",update)})}initFuntoDemos();document.addEventListener("shopify:section:load",initFuntoDemos);

  } catch(e) { console.error(e); }
})();
})();
